import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@noammazuz/vzn-feathers';
import { appState } from '@services/app-state';

import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { catchError } from 'rxjs/operators';
@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent {
  appState = appState;
  constructor(
    public authService: AuthService<any>,
    private router: Router,
  ) {

  }

}
